import React from 'react';
import { Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { v4 as uuidv4 } from 'uuid';

import ButtonLoader from '../ButtonLoader/ButtonLoader';
import OpeningListLoader from '../OpeningListLoader/OpeningListLoader';
import ParagraphLoader from '../ParagraphLoader/ParagraphLoader';
import RewardsLoader from '../RewardsLoader/RewardsLoader';

import 'react-loading-skeleton/dist/skeleton.css';
import styles from './OpeningDetailsLoader.module.scss';

const SkeletonHeader = () => (
  <Row>
    <Skeleton className={styles.headerWidth} height={18} />
    <Skeleton className={styles.contentWidth} height={10} />
  </Row>
);

const OpeningDetailsLoader = () => (
  <>
    <OpeningListLoader background={false} />
    <div className={styles.container}>
      <div className={styles.educationContainer}>
        <div className={styles.educationSubContainer}>
          <SkeletonHeader />
          <SkeletonHeader />
        </div>
        <div className={styles.educationSubContainer}>
          <SkeletonHeader />
          <SkeletonHeader />
        </div>
      </div>
    </div>
    <div className={styles.container}>
      <div className={styles.rewardsContainer}>
        <Skeleton circle width={24} height={24} />
        <Skeleton width={115} height={18} />
      </div>
      <div className={styles.rewardsContainer}>
        <RewardsLoader count={3} baseColor="#F2F4F7" highlightColor="#EAECF0" />
      </div>
    </div>
    <div className={styles.buttonsContainer}>
      <ButtonLoader count={2} width={76} height={36} />
      <ButtonLoader count={2} width={52} height={36} />
    </div>
    <div className={styles.buttonsContainer}>
      <ButtonLoader count={3} width={100} height={8} />
    </div>
    <div className={styles.paragraphContainer}>
      <div>
        <Skeleton borderRadius={6} width="15%" height={24} />
      </div>
      <div>
        {Array.from({ length: 5 }).map(() => (
          <ParagraphLoader key={uuidv4()} height={10} />
        ))}
      </div>
    </div>
  </>
);

export default OpeningDetailsLoader;
